import React from 'react';
import "./../../ReportView/ReportDetailContainer/ReportDetailContainer.scss"
import DetailViewOverlay from "./../../DetailView/DetailViewOverlay"
import { DetailsList, DetailsListLayoutMode, Selection, SelectionMode, IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { Fabric } from 'office-ui-fabric-react/lib/';
import { MarqueeSelection } from 'office-ui-fabric-react/lib/MarqueeSelection';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Dialog, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { CommandBarButton } from 'office-ui-fabric-react/lib/Button';
import { FontSizes, Stack, Text } from 'office-ui-fabric-react/lib';
import { Depths } from '@uifabric/fluent-theme/lib/fluent/FluentDepths';
import RIAccordion from "../../ConversationSafe/Accordion/RIAccordion";
import UserScreenIcon from '../../common/UserScreenBlack.svg';


import { Icon } from "office-ui-fabric-react";
import SMSIcon from "../../assets/icons/sms_icon_black.svg";

import zipcelx from 'zipcelx';
import { MyContext } from '../../../context';

const config = {
    filename: 'report',
    sheet: {
        data: [
            [{
                value: "Conversation ID",
                type: 'string'
            }, {
                value: 'ConversationType',
                type: 'string'
            }, {
                value: "Header",
                type: 'string'
            }, {
                value: "Date",
                type: 'string'
            }, {
                value: "Start",
                type: 'string'
            }, {
                value: "Duration",
                type: 'string'
            }, {
                value: "Participants",
                type: 'string'
            }, {
                value: "userLogin",
                type: 'string'
            }, {
                value: "userId",
                type: 'string'
            }, {
                value: "hasAudio",
                type: 'string'
            }, {
                value: "hasVideo",
                type: 'string'
            }, {
                value: "hasScreen",
                type: 'string'
            }, {
                value: "hasChat",
                type: 'string'
            }, {
                value: "transcript",
                type: 'string'
            }, {
                value: "size",
                type: 'string'
            }, {
                value: "hasAnalysis",
                type: 'string'
            }, {
                value: "ttl",
                type: 'string'
            }
            ]
        ]
    }
};

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px'
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden'
            }
        }
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '20px',
        maxWidth: '20px'
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px'
    },
    selectionDetails: {
        marginBottom: '20px'
    }
});

export interface IDocument {
    conversationType: Boolean,
    conversationID: String,
    conversationDirection: String,
    initiator: String,
    date: String,
    starttime: String,
    endtime: String,
    duration: String,
    attendees: String,
    notes: String,
    transcription: String

}

export interface IDetailsListDocumentsExampleState {
    columns: IColumn[];
    items: IDocument[];
    selectionDetails: string;
    isModalSelection: boolean;
    isCompactMode: boolean;
}



export default class ReportDetailContainer extends React.Component<{}, IDetailsListDocumentsExampleState> {
    _selection: Selection;
    _allItems: IDocument[];
    static contextType = MyContext;
    constructor(props: {}) {
        super(props);

        this.detailContainerRef = React.createRef();

        this._allItems = this.props.isGrouped ? [] : this._generateDocuments(props.data.entry);
        console.log("All items: ", this._allItems);
        // Integration Name column check
        const hasIntegration = this._allItems.some(item => item.integrationName);

        this._allGroupedItems = this.props.isGrouped ? this.props.data.groupedEntries.map(folder => ({
            ...folder, reportEntries: this._generateDocuments(folder.reportEntries)
        })) : []


        let columns = [
            {
                key: 'column1',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "conversationType")}</>)}</MyContext.Consumer>,
                className: classNames.fileIconCell,
                iconClassName: classNames.fileIconHeaderIcon,
                ariaLabel: 'Column operations for File type, Press to sort on File type',
                iconName: 'Page',
                isIconOnly: true,
                fieldName: 'name',
                minWidth: 16,
                maxWidth: 16,
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    const typeIcon = item.conversationType != null ? item.conversationType : "Unknown";
                    if (typeIcon === "Meeting") {
                        return <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='Group' title="Meeting" />;
                    } else if (typeIcon === "Inbound") {
                        return <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='ArrowDownRightMirrored8' title="Inbound" />;
                    } else if (typeIcon === "Outbound") {
                        return <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='ArrowUpRight8' title="Outbound" />;
                    } else if (typeIcon === "Internal") {
                        return <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='ConnectContacts' title="Internal" />;
                    } else if (typeIcon === "Chat") {
                        return <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='Chat' title="Chat" />;
                    } else if (typeIcon === "Mail") {
                        return <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='Mail' title="Mail" />;
                    } else if (typeIcon === "") {
                        return <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='CloudUpload' />;
                    }
                    else {
                        return <div></div>;
                    }
                }
            },
            {
                key: 'column2',
                name: 'Header',
                fieldName: 'topic',
                minWidth: 120,
                maxWidth: 400,
                isRowHeader: true,
                isResizable: true,
                sortAscendingAriaLabel: 'Sorted A to Z',
                sortDescendingAriaLabel: 'Sorted Z to A',
                onColumnClick: this._onColumnClick,
                data: 'string',
                isPadded: true,
                onRender: (item) => {
                    return <span>{item.topic}</span>;
                }
            },
            {
                key: 'column3',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "date")}</>)}</MyContext.Consumer>,
                fieldName: 'dateValue',
                minWidth: 70,
                maxWidth: 90,
                isResizable: true,
                data: 'date',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.date}</span>;
                }
            }, {
                key: 'column4',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "startTime")}</>)}</MyContext.Consumer>,
                fieldName: 'dateValue',
                minWidth: 70,
                maxWidth: 90,
                isResizable: true,
                data: 'date',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.starttime}</span>;
                }
            },
            {
                key: 'column5',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "duration")}</>)}</MyContext.Consumer>,
                fieldName: 'duration',
                minWidth: 50,
                maxWidth: 90,
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.duration}</span>;
                },
                isPadded: true
            },
            {
                key: 'column6',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "attendees")}</>)}</MyContext.Consumer>,
                fieldName: 'participants',
                minWidth: 70,
                maxWidth: 90,
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.participants}</span>;
                },
                isPadded: true
            },
            {
                key: 'column7',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "userId")}</>)}</MyContext.Consumer>,
                fieldName: 'userId',
                minWidth: 70,
                maxWidth: 90,
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.userId}</span>;
                },
                isPadded: true
            },
            {
                key: 'column8',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "userLogin")}</>)}</MyContext.Consumer>,
                fieldName: 'userLogin',
                minWidth: 70,
                maxWidth: 90,
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.userLogin}</span>;
                },
                isPadded: true
            },
            {
                key: 'column9',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "conversationId")}</>)}</MyContext.Consumer>,
                fieldName: 'conversationId',
                minWidth: 200,
                maxWidth: 300,
                isRowHeader: true,
                isResizable: true,
                sortAscendingAriaLabel: 'Sorted A to Z',
                sortDescendingAriaLabel: 'Sorted Z to A',
                onColumnClick: this._onColumnClick,
                data: 'string',
                isPadded: true,
                onRender: (item) => {
                    return <span>{item.conversationId}</span>;
                }
            },
            {
                key: 'column10',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "media")}</>)}</MyContext.Consumer>,
                fieldName: 'media',
                minWidth: 80,
                maxWidth: 80,
                isRowHeader: true,
                isResizable: true,
                onColumnClick: this._onColumnClick,
                data: 'string',
                isPadded: true,
                onRender: (item) => {
                    if (item.data.isVideo) {
                        return (
                            <Stack.Item style={{ padding: "0px" }}>
                                <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='Video' title="Video" />
                            </Stack.Item>
                        );
                    }
                    else {
                        return (<Stack horizontal align="start" style={{ padding: "0px" }} tokens={{ childrenGap: '10' }}>
                            {item.data.hasAudio && <Stack.Item style={{ padding: "4px" }}>
                                <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='Microphone' title="Audio" />
                            </Stack.Item>}
                            {item.data.hasScreenSharing && <Stack.Item style={{ padding: "4px" }}>
                                <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='ScreenCast' title="Screen share" />
                            </Stack.Item>}
                            {item.data.hasUserScreen && <Stack.Item style={{ padding: "4px", alignSelf: "center" }} title="User Screen">
                                <img src={UserScreenIcon} className="user-screen-icon" />

                            </Stack.Item>}
                            {item.data.hasVideo && <Stack.Item style={{ padding: "4px" }}>
                                <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='Video' title="Video" />
                            </Stack.Item>}
                            {item.data.hasChat && <Stack.Item style={{ padding: "4px" }}>
                                <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='Chat' title="Chat" />
                            </Stack.Item>}
                            {item.data.hasFiles && <Stack.Item style={{ padding: "4px" }}>
                                <Icon className="ContentColor" style={{ padding: "0px", fontSize: FontSizes.icon }} iconName='Attach' title="Files" />
                            </Stack.Item>}
                            {item.data.recordingType === "SMS" && <Stack.Item style={{ padding: "4px" }}>
                                <img src={SMSIcon} alt="SMS Icon" title="SMS" />
                            </Stack.Item>}
                        </Stack>);
                    }
                }
            }];

        const ttlColumn =
        {
            key: 'column11',
            name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "transcript")}</>)}</MyContext.Consumer>,
            fieldName: 'transcription',
            minWidth: 70,
            maxWidth: 70,
            isResizable: true,
            data: 'number',
            onColumnClick: this._onColumnClick,
            isPadded: true
        }
        const transcriptColumn = {
            key: 'column18',
            name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("detailContainer", "ttl")}</>)}</MyContext.Consumer>,
            fieldName: 'ttl',
            minWidth: 70,
            maxWidth: 70,
            isResizable: true,
            data: 'date',
            onColumnClick: this._onColumnClick,
            isPadded: true,
            onRender: (item) => {
                return <span>{item.data.ttl}</span>;
            }
        }

        // Add Integration Name column
        if (hasIntegration) {
            columns.push({
                key: 'integrationName',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("detailContainer", "integrationName")}</>)}</MyContext.Consumer>,
                fieldName: 'integrationName',
                minWidth: 120,
                maxWidth: 150,
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                isPadded: true,
                onRender: (item) => <span>{item.integrationName}</span>
            });
        }
        if (this.props.data.kpi === "Imported") {
            columns.push(ttlColumn);
            columns.push(transcriptColumn);
            columns.push(
                {
                    key: 'column17',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("detailContainer", "ScenarioID")}</>)}</MyContext.Consumer>,
                    fieldName: 'scenarioId',
                    minWidth: 200,
                    maxWidth: 300,
                    isRowHeader: true,
                    isResizable: true,
                    sortAscendingAriaLabel: 'Sorted A to Z',
                    sortDescendingAriaLabel: 'Sorted Z to A',
                    onColumnClick: this._onColumnClick,
                    data: 'string',
                    isPadded: true,
                    onRender: (item) => {
                        return <span>{item.scenarioId}</span>;
                    }
                });
        }

        if (this.props.data.kpi === "Export" || this.props.data.valueType === "storageAudio" || this.props.data.valueType === "storageVideo" || this.props.data.valueType === "storage") {
            columns.push(ttlColumn);
            columns.push(transcriptColumn);
            columns.push(
                {
                    key: 'column12',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "size")}</>)}</MyContext.Consumer>,
                    fieldName: 'totalStorageBytes',
                    minWidth: 90,
                    maxWidth: 110,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    isPadded: true,
                    onRender: (item) => {
                        return <span>{item.totalStorageBytes ? (item.totalStorageBytes / (1024 * 1024 * 1024)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'} GB</span>;
                    }
                });
        }

        if (this.props.data.kpi === "Export") {
            columns.push(ttlColumn);
            columns.push(transcriptColumn);
            columns.push(
                {
                    key: 'column13',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "notExportedError")}</>)}</MyContext.Consumer>,
                    fieldName: 'errorCode',
                    minWidth: 200,
                    maxWidth: 300,
                    isResizable: true,
                    data: 'string',
                    onColumnClick: this._onColumnClick,
                    isPadded: true,
                    onRender: (item) => {
                        return <span>{this.generateFriendlyErrorCode(item.errorCode)}</span>;
                    }
                });
            columns.push(
                {
                    key: 'notExportedReason',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "notExportedReason")}</>)}</MyContext.Consumer>,
                    fieldName: 'notExportedReason',
                    minWidth: 200,
                    maxWidth: 300,
                    isResizable: true,
                    data: 'string',
                    onColumnClick: this._onColumnClick,
                    isPadded: true,
                    onRender: (item) => {
                        return <span>{item.notExportedReason}</span>;
                    }
                });
        }
        if (this.props.data.kpi === "NotImported") {
            columns.push(ttlColumn);
            columns.push(transcriptColumn);
            columns.push(
                {
                    key: 'column13',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "notImportedError")}</>)}</MyContext.Consumer>,
                    fieldName: 'errorCode',
                    minWidth: 200,
                    maxWidth: 300,
                    isResizable: true,
                    data: 'string',
                    onColumnClick: this._onColumnClick,
                    isPadded: true,
                    onRender: (item) => {
                        return <span>{this.generateFriendlyErrorCode(item.errorCode)}</span>;
                    }
                });
        }
        if (this.props.data.kpi === "Export" || this.props.data.kpi === "NotImported") {
            columns.push(ttlColumn);
            columns.push(transcriptColumn);
            columns.push(
                {
                    key: 'column14',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "errorDescription")}</>)}</MyContext.Consumer>,
                    fieldName: 'errorMessage',
                    minWidth: 600,
                    maxWidth: 700,
                    isResizable: true,
                    data: 'string',
                    onColumnClick: this._onColumnClick,
                    isPadded: true,
                    onRender: (item) => {
                        return <span>{item.errorMessage}</span>;
                    }
                });
        }
        if (this.props.data.kpi === "PolicyCompared") {
            columns.push(ttlColumn);
            columns.push(transcriptColumn);
            columns.push({
                key: 'column15',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "hit")}</>)}</MyContext.Consumer>,
                fieldName: 'Hit Policy',
                minWidth: 600,
                maxWidth: 700,
                isResizable: true,
                data: 'string',
                isPadded: true,
                onRender: (item) => {
                    return <span>{item.data.policyComparedHit ? "Yes" : "No"}</span>
                }
            })
        }
        if (this.props.data.kpi === "CategoryCompared") {
            columns.push(ttlColumn);
            columns.push(transcriptColumn);
            columns.push({
                key: 'column16',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "hit")}</>)}</MyContext.Consumer>,
                fieldName: 'Hit Category',
                minWidth: 600,
                maxWidth: 700,
                isResizable: true,
                data: 'string',
                isPadded: true,
                onRender: (item) => {
                    return <span>{item.data.categoryComparedHit ? "Yes" : "No"}</span>
                }
            })
        }
        if (this.props.data.kpi === "QMAgentCompared") {
            columns.push(ttlColumn);
            columns.push(transcriptColumn);
            /*columns.push({
                key: 'policy',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("compliance", "policy")}</>)}</MyContext.Consumer>,
                fieldName: 'Policy',
                isResizable: true,
                data: 'string',
                isPadded: true,
                onRender: (item) => {
                    return <span>{"test"}</span>
                }
            })*/
            columns.push({
                key: 'scorecard',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("compliance", "scorecard")}</>)}</MyContext.Consumer>,
                fieldName: 'scorecardName',
                minWidth: 200,
                maxWidth: 200,
                isResizable: true,
                data: 'string',
                isPadded: true,
                onRender: (item) => {
                    return <span>{item.data.scorecardName}</span>
                }
            })
            columns.push({
                key: 'assessment',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("compliance", "assessment")}</>)}</MyContext.Consumer>,
                fieldName: 'assessment',
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                isPadded: true,
                onRender: (item) => {
                    return <span>{item.data.assessment}</span>
                }
            })
            columns.push({
                key: 'evaluationKey',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("compliance", "evaluationKey")}</>)}</MyContext.Consumer>,
                fieldName: 'evaluationKey',
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                isPadded: true,
                onRender: (item) => {
                    return <span>{item.data.evaluationKey}</span>
                }
            })
        }

        if (this.props.data.kpi === "CaseComplianceRate"
            || this.props.data.kpi === "CaseEscalationRate"
            || this.props.data.kpi === "CaseResolutionTime") {
            columns.push({
                key: 'caseName',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("detailContainer", "caseManagement")}</>)}</MyContext.Consumer>,
                fieldName: 'caseName',
                isResizable: true,
                isMultiline: true,
                data: 'string',
                onRender: (item) => {
                    let splitCases = this.props.data.categories.split(",")
                    return <span>{item.data?.incidents?.filter(i => splitCases.includes(i.caseId)).map(i => i.caseName).join(", ")}</span>
                }
            })
            columns.push({
                key: 'riskRating',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "riskRating")}</>)}</MyContext.Consumer>,
                fieldName: 'riskRating',
                isResizable: true,
                data: 'string',
                isMultiline: true,
                onRender: (item) => {
                    let splitCases = this.props.data.categories.split(",")
                    let incidents = item.data.incidents?.filter(i => splitCases.includes(i.caseId))
                    if (incidents?.length > 1) {
                        return <span>{incidents?.map(i => i.caseName + ": " + this.getRiskRatingLabel(i.riskRating)).join(", ")}</span>
                    } else {
                        return <span>{incidents?.map(i => this.getRiskRatingLabel(i.riskRating))}</span>
                    }
                }
            })
            columns.push({
                key: 'caseStatus',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("compliance", "caseStatus")}</>)}</MyContext.Consumer>,
                fieldName: 'caseStatus',
                isResizable: true,
                data: 'string',
                isMultiline: true,
                onRender: (item) => {
                    let splitCases = this.props.data.categories.split(",")
                    let incidents = item.data.incidents?.filter(i => splitCases.includes(i.caseId))
                    if (incidents?.length > 1) {
                        return <span>{incidents?.map(i => i.caseName + ": " + this.context.getTranslation("compliance", i.status.toLowerCase())).join(", ")}</span>
                    } else {
                        return <span>{incidents?.map(i => this.context.getTranslation("compliance", i.status.toLowerCase()))}</span>
                    }
                }
            })
            columns.push({
                key: 'creationDate',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("compliance", "creationDate")}</>)}</MyContext.Consumer>,
                fieldName: 'creationDate',
                isResizable: true,
                isMultiline: true,
                data: 'string',
                onRender: (item) => {
                    let splitCases = this.props.data.categories.split(",")
                    let incidents = item.data.incidents?.filter(i => splitCases.includes(i.caseId))
                    if (incidents?.length > 1) {
                        return <span>{incidents?.map(i => i.caseName + ": " + new Date(i.creationDate).toLocaleString()).join(", ")}</span>
                    } else {
                        return <span>{incidents?.map(i => new Date(i.creationDate).toLocaleString())}</span>
                    }
                }
            })
            columns.push({
                key: 'statusChangedDate',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "statusChangedDate")}</>)}</MyContext.Consumer>,
                fieldName: 'statusChangedDate',
                isResizable: true,
                isMultiline: true,
                data: 'string',
                onRender: (item) => {
                    let splitCases = this.props.data.categories.split(",")
                    let incidents = item.data.incidents?.filter(i => splitCases.includes(i.caseId))
                    if (incidents?.length > 1) {
                        return <span>{incidents?.map(i => {
                            if (i.statusChangedDate !== null)
                                return i.caseName + ": " + new Date(i.statusChangedDate).toLocaleString()
                            else {
                                return i.caseName + ": - "
                            }
                        }).join(", ")}</span>
                    } else {
                        return <span>{incidents?.map(i => {
                            if (i.statusChangedDate !== null)
                                return new Date(i.statusChangedDate).toLocaleString()
                            else {
                                return " - "
                            }
                        })}</span>
                    }
                }
            })
            columns.push({
                key: 'statusChangedUserName',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "statusChangedUserName")}</>)}</MyContext.Consumer>,
                fieldName: 'statusChangedUserName',
                onRender: (item) => {
                    let splitCases = this.props.data.categories.split(",")
                    let incidents = item.data.incidents?.filter(i => splitCases.includes(i.caseId))
                    let result = ""
                    if (incidents?.length > 1) {
                        result = incidents?.map(i => i.caseName + ": " + i.statusChangedUserName).join(", ")
                    } else {
                        result = incidents?.map(i => i.statusChangedUserName)
                    }
                    return <span>{result}</span>
                }
            })
            if (this.props.data.kpi === "CaseComplianceRate") {
                columns.push({
                    key: 'compliance',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("compliance", "compliance")}</>)}</MyContext.Consumer>,
                    fieldName: 'compliance',
                    isResizable: true,
                    isMultiline: true,
                    data: 'string',
                    onRender: (item) => {
                        let splitCases = this.props.data.categories.split(",")
                        let incidents = item.data.incidents?.filter(i => splitCases.includes(i.caseId))
                        let result = ""
                        if (incidents?.length > 1) {
                            result = incidents?.map(i => i.caseName + ": " + ((i.status === "Resolved" || i.status === "Reviewed") ? "YES" : "NO")).join(", ")
                        } else {
                            result = incidents?.map(i => (i.status === "Resolved" || i.status === "Reviewed") ? "YES" : "NO")
                        }
                        return <span>{result}</span>
                    }
                })
            }
            if (this.props.data.kpi === "CaseEscalationRate") {
                columns.push({
                    key: 'escalated',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "escalated")}</>)}</MyContext.Consumer>,
                    fieldName: 'escalated',
                    isResizable: true,
                    isMultiline: true,
                    data: 'string',
                    onRender: (item) => {
                        let splitCases = this.props.data.categories.split(",")
                        let incidents = item.data.incidents?.filter(i => splitCases.includes(i.caseId))
                        let result = ""
                        if (incidents?.length > 1) {
                            result = incidents?.map(i => i.caseName + ": " + ((i.status === "Escalated") ? "YES" : "NO")).join(", ")
                        } else {
                            result = incidents?.map(i => (i.status === "Escalated") ? "YES" : "NO")
                        }
                        return <span>{result}</span>
                    }
                })
            }
            if (this.props.data.kpi === "CaseResolutionTime") {
                columns.push({
                    key: 'resolution',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "resolution")}</>)}</MyContext.Consumer>,
                    fieldName: 'resolution',
                    isResizable: true,
                    isMultiline: true,
                    data: 'string',
                    onRender: (item) => {
                        let splitCases = this.props.data.categories.split(",")
                        let incidents = item.data.incidents?.filter(i => splitCases.includes(i.caseId))
                        let result = ""
                        if (item.data?.incidents?.length > 1) {
                            result = incidents?.map(i => i.caseName + ": " + ((i.status === "Resolved" || i.status === "Reviewed") ? "YES" : "NO")).join(", ")
                        } else {
                            result = incidents?.map(i => (i.status === "Resolved" || i.status === "Reviewed") ? "YES" : "NO")
                        }
                        return <span>{result}</span>
                    }
                })
                columns.push({
                    key: 'additionalInfo',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "additionalInfo")}</>)}</MyContext.Consumer>,
                    fieldName: 'additionalInfo',
                    isMultiline: true,
                    onRender: (item) => {
                        let splitCases = this.props.data.categories.split(",")
                        let incidents = item.data.incidents?.filter(i => splitCases.includes(i.caseId))
                        let result = ""
                        if (incidents?.length > 1) {
                            result = incidents?.map(i => {
                                const creationDate = new Date(i.creationDate)
                                const statusChangedDate = new Date(i.statusChangedDate)
                                let additionalInfo = Math.floor((statusChangedDate - creationDate) / (1000 * 60 * 60 * 24))
                                if ((i.status === "Resolved" || i.status === "Reviewed")) {
                                    return i.caseName + ": " + additionalInfo + " days"
                                } else {
                                    return i.caseName + ": 0 days"
                                }
                            }).join(", ")
                        } else {
                            result = incidents?.map(i => {
                                if ((i.status === "Resolved" || i.status === "Reviewed")) {
                                    const creationDate = new Date(i.creationDate)
                                    const statusChangedDate = new Date(i.statusChangedDate)
                                    let additionalInfo = Math.floor((statusChangedDate - creationDate) / (1000 * 60 * 60 * 24))
                                    return additionalInfo + " days"
                                } else {
                                    return "0 days"
                                }
                            })
                        }
                        return <span>{result}</span>
                    }

                })
            }
        }

        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    selectionDetails: this._getSelectionDetails()
                });
            }
        });

        this.state = {
            items: this._allItems,
            groupedItems: this._allGroupedItems,
            columns: columns,
            selectionDetails: this._getSelectionDetails(),
            isModalSelection: false,
            isCompactMode: false,
            isDialogOpen: false,
            total: this.total,
            totalSize: this.totalSize,
            totalTranscript: this.totalTranscript
        };

    }

    _onItemInvoked = (item) => {
        this.detailContainerRef.current.showPanelItem(item.conversationId, item.data)
    }

    getRiskRatingLabel = (rating) => {
        let label;
        switch (rating) {
            case "Info": label = this.context.getTranslation("compliance", "riskRatingInformation"); break;
            case "Adherence": label = this.context.getTranslation("compliance", "riskRatingAdherence"); break;
            case "Warn": label = this.context.getTranslation("compliance", "riskRatingWarning"); break;
            default: label = rating;
        }
        return label;
    }


    _onExport = (ev) => {
        var itemList = [];
        var mainSheet = config.sheet.data
        //add header to table
        itemList.push(mainSheet[0].slice());

        //add extra columns based on kpi
        if (this.props.data.kpi == "Export" || this.props.data.kpi == "NotImported")
            itemList[0].push(
                { value: 'errorCode', type: 'string' },
                { value: 'errorMessage', type: 'string' }
            )
        if (this.props.isGrouped) itemList[0].push({ value: 'Grouped name', type: 'string' })
        if (this.props.data.kpi == "PolicyCompared") itemList[0].push({ value: 'PolicyCompared Hit', type: 'string' })
        if (this.props.data.kpi == "CategoryCompared") itemList[0].push({ value: 'CategoryCompared Hit', type: 'string' })
        if (this.props.data.kpi == "Imported") itemList[0].push({ value: 'Scenario ID', type: 'string' })
        if (this.props.data.kpi == "QMAgentCompared")
            itemList[0].push(
                { value: 'Scorecard', type: 'string' },
                { value: 'Assessment', type: 'string' },
                { value: 'Evaluation Key', type: 'string' }
            )
        if (this.props.data.kpi === "CaseComplianceRate"
            || this.props.data.kpi === "CaseEscalationRate"
            || this.props.data.kpi === "CaseResolutionTime") {
            itemList[0].push(
                { value: 'Case Name', type: 'string' },
                { value: 'Risk Rating', type: 'string' },
                { value: 'Case Status', type: 'string' },
                { value: 'Creation Date', type: 'string' },
                { value: 'Status Changed Date', type: 'string' }
            )
            if (this.props.data.kpi === "CaseComplianceRate") {
                itemList[0].push({ value: 'Compliance', type: 'string' })
            }
            if (this.props.data.kpi === "CaseEscalationRate") {
                itemList[0].push({ value: 'Escalated', type: 'string' })
            }
            if (this.props.data.kpi === "CaseResolutionTime") {
                itemList[0].push({ value: 'Resolution', type: 'string' })
            }
        }
        const exportData = this.props.isGrouped ? this.state.groupedItems.flatMap(folder =>
            folder.reportEntries.map(item => ({
                ...item,
                folderName: folder.groupName
            }))) : this.state.items;
        const hasIntegration = exportData.some(item => item.integrationName && item.integrationName !== "Teams");
        if (hasIntegration) itemList[0].push({ value: 'Integration Name', type: 'string' })

        exportData.forEach((anItem) => {
            itemList.push(
                [
                    {
                        value: anItem.conversationId,
                        type: 'string'
                    }, {
                        value: anItem.conversationType,
                        type: 'string'
                    }, {
                        value: anItem.topic,
                        type: 'string'
                    }, {
                        value: anItem.date,
                        type: 'string'
                    }, {
                        value: anItem.starttime,
                        type: 'string'
                    }, {
                        value: anItem.duration,
                        type: 'string'
                    }, {
                        value: anItem.participants,
                        type: 'string'
                    }, {
                        value: anItem.userLogin,
                        type: 'string'
                    }, {
                        value: anItem.userId,
                        type: 'string'
                    }, {
                        value: anItem.data.hasAudio ? 1 : 0,
                        type: 'number'
                    }, {
                        value: anItem.data.hasVideo ? 1 : 0,
                        type: 'number'
                    }, {
                        value: anItem.data.hasScreenSharing ? 1 : 0,
                        type: 'number'
                    }, {
                        value: anItem.data.hasChat ? 1 : 0,
                        type: 'number'
                    }, {
                        value: anItem.transcription,
                        type: 'number'
                    }, {
                        value: anItem.size,
                        type: 'number'
                    }, {
                        value: anItem.data.hasAnalysis ? 1 : 0,
                        type: 'number'
                    }, {
                        value: anItem.data.ttl,
                        type: 'string'
                    }
                ])

            if (this.props.data.kpi == "NotImported" || this.props.data.kpi == "Export") {
                itemList[itemList.length - 1].push(
                    {
                        value: anItem.errorCode,
                        type: 'string'
                    },
                    {
                        value: anItem.errorMessage,
                        type: 'string'
                    }
                );

            }



            if (this.props.isGrouped) {
                itemList[itemList.length - 1].push({
                    value: anItem.folderName, type: 'string'
                })
            }
            if (this.props.data.kpi == "PolicyCompared") itemList[itemList.length - 1].push({
                value: anItem.policyComparedHit, type: 'string'
            })
            if (this.props.data.kpi == "CategoryCompared") itemList[itemList.length - 1].push({
                value: anItem.categoryComparedHit, type: 'string'
            })
            if (this.props.data.kpi == "QMAgentCompared") {
                itemList[itemList.length - 1].push(
                    {
                        value: anItem.scorecardName, type: 'string'
                    },
                    {
                        value: anItem.assessment, type: 'string'
                    },
                    {
                        value: anItem.evaluationKey, type: 'string'
                    }
                )
            }
            if (this.props.data.kpi == "Imported") itemList[itemList.length - 1].push({
                value: anItem.scenarioId, type: 'string'
            })
            if (this.props.data.kpi === "CaseComplianceRate"
                || this.props.data.kpi === "CaseEscalationRate"
                || this.props.data.kpi === "CaseResolutionTime") {

                let splitCases = this.props.data.categories.split(",")
                const incidents = anItem.data?.incidents.filter(i => splitCases.includes(i.caseId)) || [];
                const multipleIncidents = incidents.length > 1;

                itemList[itemList.length - 1].push(
                    {
                        value: incidents.map(i => i.caseName).join(", "),
                        type: 'string'
                    },
                    {
                        value: multipleIncidents
                            ? incidents.map(i => i.caseName + ": " + this.getRiskRatingLabel(i.riskRating)).join(", ")
                            : incidents.map(i => this.getRiskRatingLabel(i.riskRating)).join(""),
                        type: 'string'
                    },
                    {
                        value: multipleIncidents
                            ? incidents.map(i => i.caseName + ": " + this.context.getTranslation("compliance", i.status.toLowerCase())).join(", ")
                            : incidents.map(i => this.context.getTranslation("compliance", i.status.toLowerCase())).join(""),
                        type: 'string'
                    },
                    {
                        value: multipleIncidents
                            ? incidents.map(i => i.caseName + ": " + new Date(i.creationDate).toLocaleString()).join(", ")
                            : incidents.map(i => new Date(i.creationDate).toLocaleString()).join(""),
                        type: 'string'
                    },
                    {
                        value: multipleIncidents
                            ? incidents.map(i => i.caseName + ": " + new Date(i.statusChangedDate).toLocaleString()).join(", ")
                            : incidents.map(i => new Date(i.statusChangedDate).toLocaleString()).join(""),
                        type: 'string'
                    }
                );

                if (this.props.data.kpi === "CaseComplianceRate") {
                    itemList[itemList.length - 1].push({
                        value: multipleIncidents
                            ? incidents.map(i => i.caseName + ": " + ((i.status === "Resolved" || i.status === "Reviewed") ? "yes" : "no")).join(", ")
                            : incidents.map(i => (i.status === "Resolved" || i.status === "Reviewed") ? "yes" : "no").join(""),
                        type: 'string'
                    })
                }
                if (this.props.data.kpi === "CaseEscalationRate") {
                    itemList[itemList.length - 1].push({
                        value: multipleIncidents
                            ? incidents.map(i => i.caseName + ": " + ((i.status === "Escalated") ? "yes" : "no")).join(", ")
                            : incidents.map(i => (i.status === "Escalated") ? "yes" : "no").join(""),
                        type: 'string'
                    })
                }
                if (this.props.data.kpi === "CaseResolutionTime") {
                    itemList[itemList.length - 1].push({
                        value: multipleIncidents
                            ? incidents.map(i => i.caseName + ": " + ((i.status === "Resolved" || i.status === "Reviewed") ? "yes" : "no")).join(", ")
                            : incidents.map(i => (i.status === "Resolved" || i.status === "Reviewed") ? "yes" : "no").join(""),
                        type: 'string'
                    })
                }
            }
        });
        config.sheet.data = itemList;
        zipcelx(config)
        config.sheet.data = mainSheet
        this.setState({ isDialogOpen: true });
    }


    _dialogClose = () => this.setState({ isDialogOpen: false })

    render() {
        const { columns, items, isModalSelection } = this.state;

        return (
            <MyContext.Consumer>
                {(context) => (<Fabric>
                    <DetailViewOverlay authorization={this.props.authorization} client={this.props.apol} ref={this.detailContainerRef} loading={true} userRules={this.props.userRules} theme={this.props.theme} />
                    <Dialog
                        isOpen={this.state.isDialogOpen}
                        type={DialogType.close}
                        onDismiss={this._dialogClose.bind(this)}
                        title='Excel export'
                        subText='Excel file created and downloaded to your favourite directory'
                        isBlocking={false}
                        closeButtonAriaLabel='Close'
                    />
                    <header className="report-panel-header ms-Grid-row" style={{ boxShadow: Depths.depth8 }}>
                        {/* == Recording Header ========================================= */}

                        <Stack horizontal>

                            <Text style={{ padding: "5px" }} >{this.translateDefaultTitles(this.props.data.title, context)}{this.props.data.overflow && ": Data Overflow"}</Text>
                            <Text style={{ padding: "5px" }} >{context.getTranslation("dashboard", this.props.data.kpi)}</Text>
                            <Text style={{ padding: "5px" }} >{this.props.data.kpi === "Export" ? this.state.total + ", " + this.state.totalSize.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " GB, " + this.state.totalTranscript : ""}</Text>

                            <Stack.Item grow={2} ><div /></Stack.Item>

                            <SearchBox
                                placeholder="Search"
                                onChange={(event, newValue) => {
                                    if (event != null) event.persist();
                                    if (this.props.isGrouped) {
                                        this.setState({
                                            groupedItems: newValue ? this._allGroupedItems.map(folder => ({
                                                ...folder, reportEntries: folder.reportEntries.filter(i => (i.topic.toLowerCase().indexOf(newValue.toLowerCase()) > -1)
                                                    || (i.transcription.toLowerCase().indexOf(newValue.toLowerCase()) > -1)
                                                    || (i.notes.toLowerCase().indexOf(newValue.toLowerCase()) > -1)
                                                    || (i.userId.toLowerCase().indexOf(newValue.toLowerCase()) > -1)
                                                    || (i.conversationId.toLowerCase().indexOf(newValue.toLowerCase()) > -1)
                                                    || (i.participants.toLowerCase().indexOf(newValue.toLowerCase()) > -1)
                                                    || (i.userLogin.toLowerCase().indexOf(newValue.toLowerCase()) > -1))

                                            })) : this._allGroupedItems
                                        })
                                    }
                                    else {

                                        this.setState({
                                            items: newValue ? this._allItems.filter(i => {
                                                return (
                                                    i.topic.toLowerCase().indexOf(newValue.toLowerCase()) > -1
                                                    || i.transcription.toString().toLowerCase().indexOf(newValue.toLowerCase()) > -1
                                                    || i.notes.toLowerCase().indexOf(newValue.toLowerCase()) > -1
                                                    || i.userId.toLowerCase().indexOf(newValue.toLowerCase()) > -1
                                                    || i.conversationId.toLowerCase().indexOf(newValue.toLowerCase()) > -1
                                                    || i.userLogin.toLowerCase().indexOf(newValue.toLowerCase()) > -1
                                                    || i.participants.toLowerCase().indexOf(newValue.toLowerCase()) > -1
                                                )
                                            }
                                            ) : this._allItems
                                        });
                                    }
                                }}
                            />
                            <CommandBarButton
                                iconProps={{ iconName: 'Download' }}
                                text="Export Report"
                                style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.Icon }}
                                onClick={this._onExport}
                                disabled={!(this.props.isOwner || this.props.isManager || this.props.hasEntryListDownload)}
                            />
                        </Stack>
                    </header>
                    <div className="report-details-wrapper">

                        {/* == Player and meta data. ===================================== */}

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                <div className="ms-Grid-row">



                                </div>
                                {this.props.isGrouped && (

                                    <RIAccordion theme={this.props.theme}
                                        data={this.state.groupedItems.sort((a, b) => b.reportEntries.length - a.reportEntries.length).map((folder, i) => {
                                            return ({
                                                header: <div>{folder.groupName} ({folder.reportEntries.length})</div>,
                                                content:
                                                    <MarqueeSelection selection={this._selection}>
                                                        <DetailsList
                                                            items={folder.reportEntries}
                                                            columns={columns}
                                                            selectionMode={isModalSelection ? SelectionMode.multiple : SelectionMode.none}
                                                            setKey="set"
                                                            layoutMode={DetailsListLayoutMode.justified}
                                                            isHeaderVisible={true}
                                                            selection={this._selection}
                                                            selectionPreservedOnEmptyClick={true}
                                                            onActiveItemChanged={this._onItemInvoked}
                                                            enterModalSelectionOnTouch={true}
                                                            ariaLabelForSelectionColumn="Toggle selection"
                                                            ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                                        />
                                                    </MarqueeSelection>

                                            })
                                        })}>
                                    </RIAccordion>
                                )}
                                {!this.props.isGrouped && (
                                    <MarqueeSelection selection={this._selection}>
                                        <DetailsList
                                            items={items}
                                            columns={columns}
                                            selectionMode={isModalSelection ? SelectionMode.multiple : SelectionMode.none}
                                            setKey="set"
                                            layoutMode={DetailsListLayoutMode.justified}
                                            isHeaderVisible={true}
                                            selection={this._selection}
                                            selectionPreservedOnEmptyClick={true}
                                            onActiveItemChanged={this._onItemInvoked}
                                            enterModalSelectionOnTouch={true}
                                            ariaLabelForSelectionColumn="Toggle selection"
                                            ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                        />
                                    </MarqueeSelection>

                                )}
                            </div> {/* end of main contenten */}
                        </div>
                    </div>
                </Fabric>)
                }
            </MyContext.Consumer>);

    }
    componentDidUpdate(previousProps: any, previousState: IDetailsListDocumentsExampleState) {
        if (previousState.isModalSelection !== this.state.isModalSelection && !this.state.isModalSelection) {
            this._selection.setAllSelected(false);
        }
    }

    //Needs to be removed
    _onChangeText = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string): void => {

        this.setState({
            items: text ? this._allItems.filter(i => i.topic.toLowerCase().indexOf(text) > -1) : this._allItems
        });
    };
    //Needs to be removed

    _getSelectionDetails(): string {
        const selectionCount = this._selection.getSelectedCount();

        switch (selectionCount) {
            case 0:
                return 'No items selected';
            case 1:
                return '1 item selected: ' + (this._selection.getSelection()[0]).name;
            default:
                return `${selectionCount} items selected`;
        }
    }

    _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { columns, items } = this.state;
        const newColumns: IColumn[] = columns.slice();
        const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        const newItems = _copyAndSort(items, currColumn.fieldName, currColumn.isSortedDescending);
        this.setState({
            columns: newColumns,
            items: newItems
        });
    };

    //Needs to be removed
    _onChangeText = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string): void => {
        this.setState({
            items: text ? this._allItems.filter(i => i.topic.toLowerCase().indexOf(text) > -1) : this._allItems
        });
    };
    //Needs to be removed

    _generateDocuments = (DataArr) => {
        const items = [];
        if (DataArr !== undefined) {
            this.totalSize = 0;
            this.totalTranscript = 0;
            this.total = 0;
            for (let i = 0; i < DataArr.length; i++) {
                let participants = "";
                if (DataArr[i].linkedUser != null) {
                    participants += DataArr[i].linkedUser.length;
                    DataArr[i].linkedUser.map((item, i) => {
                        participants += ", " + item.name;
                    });
                }
                
                // Format storage last updated date for storage consumption reports
                let formattedDate = DataArr[i].day;
                let formattedTime = DataArr[i].timein;
                let dateValue = DataArr[i].callStartMs;
                
                if (this.props.data.valueType === "size" && DataArr[i].storageLastUpdated) {
                    const storageDate = new Date(DataArr[i].storageLastUpdated);
                    dateValue = storageDate.getTime().toString();
                    formattedDate = storageDate.toLocaleDateString();
                    formattedTime = storageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                }
                
                items.push({
                    id: DataArr[i].id,
                    conversationType: DataArr[i].recordingType,
                    topic: DataArr[i].topic != null ? DataArr[i].topic : "",
                    conversationDirection: DataArr[i].recordingType,
                    conversationId: DataArr[i].conversationId,
                    date: formattedDate,
                    dateValue: dateValue,
                    starttime: formattedTime,
                    duration: DataArr[i].duration,
                    userId: DataArr[i].userId,
                    userLogin: DataArr[i].userLogin,
                    botAppId: DataArr[i].botAppId,
                    participants: participants,
                    notes: DataArr[i].notes != null ? DataArr[i].notes : "",
                    transcription: DataArr[i].speech2Text != null ? DataArr[i].speech2Text : 0,
                    totalStorageBytes: DataArr[i].totalStorageBytes,
                    size: DataArr[i].size,
                    exportComment: DataArr[i].exportComment,
                    data: DataArr[i],
                    errorMessage: DataArr[i].errorMessage,
                    errorCode: DataArr[i].errorCode,
                    scenarioId: DataArr[i].scenarioId,
                    notExportedReason: DataArr[i].notExportedReason,
                    integrationName: DataArr[i].integrationName,
                });
                if (this.props.data.kpi == "PolicyCompared") items[items.length - 1].policyComparedHit = DataArr[i].policyComparedHit
                if (this.props.data.kpi == "CategoryCompared") items[items.length - 1].categoryComparedHit = DataArr[i].categoryComparedHit
                this.total++;
                this.totalSize += DataArr[i].totalStorageBytes ? DataArr[i].totalStorageBytes / (1024 * 1024 * 1024) : (DataArr[i].size || 0);
                this.totalTranscript += parseInt(DataArr[i].speech2Text);
                if (this.props.data.kpi == "QMAgentCompared") {
                    items[items.length - 1].scorecardName = DataArr[i].scorecardName
                    items[items.length - 1].assessment = DataArr[i].assessment
                    items[items.length - 1].evaluationKey = DataArr[i].evaluationKey
                }
            }
        }
        return items;
    }

    generateFriendlyErrorCode = (errCode) => {
        switch (errCode) {
            case "UNKNOWN":
                return "Unknown";
            case "FILE_NOT_FOUND":
                return "File not found";
            case "COULD_NOT_IMPORT_CONV":
                return "Could not import conversation";
            case "EXCEPTION":
                return "Exception"
            case "COULD_NOT_IMPORT_METADATA":
                return "Could not import metadata";
            case "CONV_EXISTS_ALREADY":
                return "Conversation already exists";
            case "USER_NOT_FOUND":
                return "User not found";
            case "INVALID_FORMAT":
                return "Invalid format";
            case "MEDIA_PROCESSING":
                return "Media processing";
            case "DATABASE_ERROR":
                return "Database error";
            case "FILE_TRANSFER":
                return "File transfer";
            case "PENDING":
                return "Pending";
            case "NO_ERROR":
                return "No error";
            case "MAPPING_USER_MISSING":
                return "Mapping user missing";
            case "USER_NOT_LICENSED":
                return "User not licensed";
            case "ACCOUNT_NOT_PROVISIONED":
                return "Account not provisioned";
            case "MEDIA_PROCESSING_FAILED":
                return "Media processing failed";
            case "WEBHOOK_ERROR":
                return "Webhook error";
            case "CHAT_ANALYTICS_FAILED":
                return "Chat analytics failed";
            case "METADATA_PERSISTENCE_FAILED":
                return "Metadata persistence failed";
            case "STORAGE_WRITE_FAILED":
                return "Storage write failed";
            case "PROCESSING_ERROR":
                return "Processing error";
            default: return ""
        }
    }

    //translate only default titles, if it's not a match will show original title
    translateDefaultTitles = (title, context) => {
        const phrases = {
            "Conversations Recorded per Month during the Year": "conversationsRecordedPerMonthDuringYear",
            "Conversations Recorded per Day during Last Month": "conversationsRecordedPerDayDuringLastMonth",
            "Conversations Recorded per Hour Yesterday": "conversationsRecordedPerHourYesterday",
            "Conversations Recorded per Day during Last Week": "conversationsRecordedPerDayDuringLastWeek",
            "Detailed Report on Call Recording Problems by Category": "detailedReportOnCallRecordingProblemsByCategory",
            "Conversations Recorded vs. the Calls with Problems": "conversationsRecordedVsCallsWithProblems",
            "System Activity: Users being Recorded": "systemActivityUsersBeingRecorded",
            "System Availability: Bot Clusters & Backend Services (0=working, 1=problems)": "systemAvailabilityBotClustersBackendServices",
            "System Activity: Total Duration of Recordings": "systemActivityTotalDurationOfRecordings",
            "System Activity: Number of Deleted Conversations": "systemActivityNumberOfDeletedConversations",
            "Total Duration of Recordings": "totalDurationOfRecordings",
            "Recorded Conversations Breakdown by Days & Type": "recordedConversationsBreakdownByDaysType",
            "Call Conversations Today": "callConversationsToday",
            "Inbound Call Conversations": "inboundCallConversations",
            "Outbound Call Conversations": "outboundCallConversations"
        };

        return (phrases[title] ? context.getTranslation("dashboard", phrases[title]) : title);
    }
}



//function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
//    const key = columnKey;
//    return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
//}

function _copyAndSort(items, columnKey, isSortedDescending) {
    return items.slice(0).sort((a, b) => {
        if (columnKey === 'assessment') {
            const aAssessment = (a.data?.assessment || "0/0");
            const bAssessment = (b.data?.assessment || "0/0");

            const [aVal, aMax] = aAssessment.split('/').map(parseFloat);
            const [bVal, bMax] = bAssessment.split('/').map(parseFloat);

            if (aMax !== bMax) {
                return isSortedDescending ? bMax - aMax : aMax - bMax;
            }
            return isSortedDescending ? bVal - aVal : aVal - bVal;
        }

        if (columnKey === 'evaluationKey') {
            const aKey = a.data?.evaluationKey || '';
            const bKey = b.data?.evaluationKey || '';
            const result = aKey.localeCompare(bKey);
            return isSortedDescending ? -result : result;
        }

        // Logica originale per le altre colonne
        const key = columnKey;
        return (isSortedDescending
            ? a[key] < b[key]
            : a[key] > b[key]) ? 1 : -1;
    });
}





